export function formatDate(dateString) {
  const date = new Date(dateString);
  const today = new Date();

  // Remove the time part for comparison (compare only year, month, and day)
  today.setHours(0, 0, 0, 0);
  date.setHours(0, 0, 0, 0);

  // Format the date as "26 Dec 2024"
  const options = { year: 'numeric', month: 'short', day: 'numeric' };
  const formattedDate = date.toLocaleDateString('en-GB', options);

  // Format the time as "07:41 AM"
  const formattedTime = date.toLocaleTimeString('en-GB', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
  });

  // If the date is today's date, only return the time
  if (date.getTime() === today.getTime()) {
    return formattedTime;
  }

  // Otherwise, return the full date and time
  return `${formattedDate}`;
}
export function formatDatecase(dateString) {
  const date = new Date(dateString);

  // Format the date as "26 Dec 2024"
  const options = { year: 'numeric', month: 'short', day: 'numeric' };
  const formattedDate = date.toLocaleDateString('en-GB', options);

  return formattedDate;
}


export function formatFullDate(isoDate) {
  const date = new Date(isoDate);
  const options = { year: "numeric", month: "short", day: "2-digit" };
  const formattedDate = date.toLocaleDateString("en-US", options);
  return formattedDate;
}


export const getCurrentDateTime = (dateString = null) => {
  const now = dateString ? new Date(dateString) : new Date();
  if (isNaN(now.getTime())) return "";
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  const hours = String(now.getHours()).padStart(2, '0');
  const minutes = String(now.getMinutes()).padStart(2, '0');

  return `${year}-${month}-${day}T${hours}:${minutes}`;
};




export function formatToMonthYear(isoDate) {
  const date = new Date(isoDate);
  const options = { month: 'long', year: 'numeric' };
  return date.toLocaleDateString('en-US', options);
}
export const convertToTime = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true });
};
export const convertToTimeFormat = (timeString) => {
  const date = new Date(timeString);
  const istOffset = 5.5 * 60 * 60 * 1000;
  const istTime = new Date(date.getTime() + istOffset);
  const humanReadableTime = istTime.toLocaleTimeString("en-IN", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
  return humanReadableTime;
};
export const convertToTimeFormatuserprofile = (timeString) => {
  const date = new Date(timeString);
  return date.toLocaleTimeString("en-IN", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
    timeZone: "UTC",
  });
};


export const convertToCustomFormat = (timeString) => {
  const date = new Date(timeString);
  const now = new Date();

  // Check if the date is today or yesterday
  const isToday = date.toDateString() === now.toDateString();
  const isYesterday = new Date(now.setDate(now.getDate() - 1)).toDateString() === date.toDateString();

  let formattedDate;

  if (isToday) {
    formattedDate = `Today, ${date.toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    })}`;
  } else if (isYesterday) {
    formattedDate = `Yesterday, ${date.toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    })}`;
  } else {
    formattedDate = date.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    }) + `, ${date.toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    })}`;
  }

  return formattedDate;
};
// export const convertToTargetFormat = (timeString) => {
//   // Parse the input date
//   const date = new Date(timeString);
//   const targetYear = 2025;
//   const targetMonth = 0; 
//   const targetDay = 12;
//   const targetHour = 15;
//   const targetMinute = 6;
//   date.setUTCFullYear(targetYear);
//   date.setUTCMonth(targetMonth);
//   date.setUTCDate(targetDay);
//   date.setUTCHours(targetHour);
//   date.setUTCMinutes(targetMinute);
//   date.setUTCSeconds(0);
//   date.setUTCMilliseconds(0);
//   // Format the new date to the desired output format
//   const formattedDate = date.toISOString().slice(0, 16);
//   return formattedDate; // Returns "2025-01-12T15:06"
// }
export const convertToTargetFormat = (timeString) => {
  // Parse the input date
  const date = new Date(timeString);

  // Get the current date dynamically in local time
  const today = new Date();

  // Set the dynamic date values based on today's date (local time)
  const targetYear = today.getFullYear();
  const targetMonth = today.getMonth();  // Month is zero-based, so January is 0
  const targetDay = today.getDate();
  const targetHour = today.getHours();
  const targetMinute = today.getMinutes();

  // Apply the current date values to the original date
  date.setFullYear(targetYear);
  date.setMonth(targetMonth);
  date.setDate(targetDay);
  date.setHours(targetHour);
  date.setMinutes(targetMinute);
  date.setSeconds(0);
  date.setMilliseconds(0);

  const formattedDate = date.toISOString().slice(0, 16);
  return formattedDate;
}









